import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { GraceChangeImpact } from '@/pages/renewal-settings-support'

export function AffectedMembersDialog(props: {
  impact: GraceChangeImpact | null
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Members affected by this change</DialogTitle>
          <DialogDescription>
            These members will lapse at the next Renewal Pipeline run.
          </DialogDescription>
        </DialogHeader>
        <ul className="divide-y divide-border text-body-sm">
          {props.impact?.members.map((member) => (
            <li key={member.person_id} className="py-2">
              {member.name}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
